module.exports = __webpack_public_path__ + "static/media/train.db3d0810.svg";